import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const ArrowUp = createSvgIcon(
  <path d="M23.979 17.137 12 5.16.021 17.138l1.591 1.59L12 8.341l10.387 10.388 1.591-1.591Z" />,
  'ArrowUp'
);

export { ArrowUp };
